import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';

const HumanVerifiedBadge = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: {
      container: 'px-2 py-1 text-xs',
      icon: 'w-3 h-3',
      text: 'text-xs'
    },
    default: {
      container: 'px-3 py-1.5 text-sm',
      icon: 'w-4 h-4',
      text: 'text-sm'
    },
    large: {
      container: 'px-4 py-2 text-base',
      icon: 'w-5 h-5',
      text: 'text-base'
    }
  };

  const sizeClasses = sizes[size] || sizes.default;

  return (
    <div 
      className={`
        inline-flex items-center gap-1.5 
        bg-gradient-to-r from-blue-500 to-cyan-500 
        text-white font-semibold rounded-full
        ${sizeClasses.container} ${className}
      `}
      title="Human Verified Creator - Confirmed authentic artist"
    >
      <Shield className={sizeClasses.icon} fill="currentColor" />
      <CheckCircle className={`${sizeClasses.icon} -ml-1`} />
      {showText && <span className={sizeClasses.text}>Human Verified</span>}
    </div>
  );
};

export default HumanVerifiedBadge;
